

const r = /[^a-zA-Z0-9 \-]/;

export const isArticleTitle = (s: string) => {
  return !r.test(s);
};
